"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeRangeBoundaries = exports.isValidRange = exports.normalizeStep = exports.getValueFromPercentage = exports.normalizeToClosestValue = exports.calculateValueFromPercentage = exports.convertValueToPercentage = exports.decimalPlaces = void 0;

/**
 * Calculates the decimal places.
 * @param num
 * @returns {number}
 */
var decimalPlaces = function decimalPlaces(num) {
  var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

  if (!match) {
    return 0;
  }

  return Math.max(0, // Number of digits right of decimal point.
  (match[1] ? match[1].length : 0) - ( // Adjust for scientific notation.
  match[2] ? +match[2] : 0));
};
/**
 * @desc
 * Converts the value to percentage.
 * @param min
 * @param max
 * @param step
 * @param value
 * @returns {number}
 */


exports.decimalPlaces = decimalPlaces;

var convertValueToPercentage = function convertValueToPercentage(min, max, step, value) {
  return (value - min) / (max - min) * 100;
};
/**
 * Find the value for the current percentage.
 * @param percentage
 * @param step
 * @param min
 * @param max
 * @param precision
 * @returns {string}
 */


exports.convertValueToPercentage = convertValueToPercentage;

var calculateValueFromPercentage = function calculateValueFromPercentage(min, max, step, percentage, precision) {
  var res = min + (max - min) * (percentage / 100); // These next two comparisons are done when the closest value would determine a value that is not the max/min
  // For example:  0 = min, 100 = max, step 16.

  if (percentage <= 0) {
    return min;
  }

  if (percentage >= 100) {
    return max;
  }

  return normalizeToClosestValue({
    min: min,
    max: max,
    value: res,
    step: step,
    precision: precision
  });
};
/**
 * Normalizes the calculated value to the closest value, according to current step.
 * @param value
 * @param step
 * @param min
 * @param max
 * @param precision
 * @returns {number|array}
 */


exports.calculateValueFromPercentage = calculateValueFromPercentage;

var normalizeToClosestValue = function normalizeToClosestValue(_ref) {
  var min = _ref.min,
      max = _ref.max,
      value = _ref.value,
      step = _ref.step,
      precision = _ref.precision;

  // If the value is a range of values [range=true]
  if (Array.isArray(value)) {
    var values = [normalizeToClosestValue({
      min: min,
      max: max,
      value: value[0],
      step: step,
      precision: precision
    }), normalizeToClosestValue({
      min: min,
      max: max,
      value: value[1],
      step: step,
      precision: precision
    })];
    return normalizeRangeBoundaries(values, step, values[0] <= min ? 1 : 0);
  }

  var modulo = (value - min) % step;
  var halfStep = step / 2;
  var closestValue = (value - modulo + step).toFixed(precision);

  if (modulo < halfStep) {
    closestValue = (value - modulo).toFixed(precision);
  }
  /*
  *Another way of calculating the closest value:
   const valueInRange = value - min
   const closestStep = Math.round(valueInRange / step)
   const closestValue = (closestStep * step + min).toFixed(precision)
  * */


  if (closestValue > max) {
    return max;
  }

  if (closestValue < min) {
    return min;
  }

  return Number(closestValue);
};
/**
 * @desc
 * Return the current value from the values array.
 * As a fallback it return the old value.
 * @param min
 * @param max
 * @param step
 * @param precision
 * @param percentage
 * @returns {number}
 */


exports.normalizeToClosestValue = normalizeToClosestValue;

var getValueFromPercentage = function getValueFromPercentage(min, max, step, percentage, precision) {
  var normalizedPercentage = percentage;

  if (percentage < 0) {
    normalizedPercentage = 0;
  } else if (percentage > 100) {
    normalizedPercentage = 100;
  }

  var normalizedValue = calculateValueFromPercentage(min, max, step, normalizedPercentage, precision);
  return Number(normalizedValue);
};
/**
 * Normalize the step size by limiting it for a value which will generate maximally 1000 items.
 * @param step
 * @param min
 * @param max
 * @returns {number}
 */


exports.getValueFromPercentage = getValueFromPercentage;

var normalizeStep = function normalizeStep(step, min, max) {
  var start = parseFloat(min);
  var stop = parseFloat(max);
  var length = Math.round((stop - start) / parseFloat(step));

  if (length > 1000) {
    // calculate new step which gives us 1000 values
    var newStep = Math.round((stop - start) / 1000);
    console.warn('Step for the SeekBar component was changed to', newStep);
    return newStep;
  }

  return step;
};
/**
 * Checks if the range is valid - first number is smaller then second.
 * @param values
 * @returns {boolean}
 */


exports.normalizeStep = normalizeStep;

var isValidRange = function isValidRange(values) {
  return Array.isArray(values) ? values[0] < values[1] : true;
};
/**
 * Normalizes the boundaries of a range to a given index.
 * @param values
 * @param step
 * @param index
 * @returns {(number|*)[]|*[]|*}
 */


exports.isValidRange = isValidRange;

var normalizeRangeBoundaries = function normalizeRangeBoundaries(values, step, index) {
  if (isValidRange(values)) return values;

  if (Array.isArray(values)) {
    if (index === 0) {
      return [values[1] - step, values[1]];
    }

    return [values[0], values[0] + step];
  }

  return values;
};

exports.normalizeRangeBoundaries = normalizeRangeBoundaries;
//# sourceMappingURL=utils.js.map